<template>
  <div id="app">
    <img src="./assets/icon.png" alt="LeCard" id="imgEmpresa" class="d-none">

    <div v-if="!load">
      <router-view/>
    </div>

    <loading full="true" :text="errServer" v-else/>

    <div class="modal modal-loading d-block" v-if="loadingGeral" style="z-index: 2090">
      <div class="modal-content border-0">
        <div style="padding: 24px 6px 32px">
          <loading :text="loadingGeral" :ellipsis="true"/>
        </div>
      </div>
    </div>

    <fila-chatbot ref="fila" :empresa="user"/>
  </div>
</template>

<script>
  import Vue from "vue";
  import Loading from "@/components/commons/Loading";
  import FilaChatbot from "@/views/FilaChatbot";

  export default {
    components: {FilaChatbot, Loading},
    name: 'App',
    data() {
      return {
        iniciou: false,
        load: true,
        user: {},
        audio: null,
        errServer: '',
        loadAtend: false,
        pesquisa: { keys: [] },
        authRequests: null,
        pedidosTimer: null,
        hasHttpInterceptor: false
      }
    },

    methods: {
      configurarHttpInterceptor() {
        if (this.hasHttpInterceptor) {
          return;
        }

        this.hasHttpInterceptor = true;

        Vue.http.interceptors.push((request, next) => {
          if (this.x_auth && !request.headers.get('x-lecard-key')) {
            request.headers.set('x-lecard-key', this.x_auth);
          }

          next();
        });
      },

      async autenticar(index, callback) {
        try {
          const result = await this.$store.dispatch('autenticarEmpresa', {
            http: this.$http,
            baseServer: this.base_server,
            index,
            authRequests: this.authRequests
          });

          if (result && result.success) {
            this.configurarHttpInterceptor();

            if (result.empresa.isDefault || result.statusEmpresa !== '2' || result.habilitarLebot !== '1') {
              if (result.statusEmpresa !== '2') {
                if (this.$route.name !== 'Block') {
                  this.$router.push('/block');
                }

                this.load = false;
                return;
              }

              if (result.habilitarLebot !== '1') {
                if (this.$route.name !== 'Upgrade') {
                  this.$router.push('/upgrade');
                }

                this.load = false;
                return;
              }

              if (['Login'].includes(this.$route.name)) {
                this.$router.push(this.isElectron ? '/home' : '/chamados');
              }
            }

            callback(result.response);
            return;
          }

          if (!(result && result.unauthorized)) {
            this.$swal("Atenção!", "Não conseguimos autenticar sua empresa. Por favor tente novamente!");
            this.load = false;
          }

          callback(false);

        } catch (res) {
          if (!res.status) {
            this.errServer = this.$helpers.verificarServerAlternativo(this.server_alternativo);

          } else {
            this.errServer = "No momento este canal está indisponível.\nPor favor verifique se sua conexão está estável."
          }
        }
      },

      atualizarPedidos() {
        return this.$store.dispatch('pedidosColetados/atualizar', this.$http).catch(() => {});
      },

      getAtendimentos() {
        if (this.loadAtend) {
          return;
        }

        this.loadAtend = true;

        this.$http.get('chatbot/chamados', { params: this.pesquisa })
          .then(response => {
            this.loadAtend = false;
            const data = response && response.data ? response.data : []

            this.$store.dispatch('setAtendimentosEmpresas', data);

            if (data.length > 0) {
              this.playNotification();
            }

          }, res => {
            this.loadAtend = false;
            this.$swal(res.data.msg || 'Erro temporário');
          });
      },

      playNotification() {
        if (this.canPlay && this.audio && this.audio.paused) {
          this.audio.play();
        }
      },

      requestHuman(data) {
        this.getAtendimentos();

        if (!this.audio) {
          this.audio = new Audio("https://lecard-cdn.nyc3.cdn.digitaloceanspaces.com/lecard-gestor/lebot-bell.mp3");
        }

        if (typeof Notification !== 'undefined' && Notification.permission === 'granted') {
          try {
            new Notification('Solicitação de atendimento!', {
              body: 'Nova solicitação de atendimento',
              icon: document.getElementById('imgEmpresa').src
            });
          } catch (error) {
            console.warn('Não foi possível exibir a notificação de atendimento.', error);
          }
        }

        if (data && data.telefone) {
          setTimeout(() => {
            const session = this.wpp_session.find(w => w.token === data.token && String(w.phone) === String(data.chat));

            if (session) {
              window.control.markUnread({ phone: data.telefone, wpp: session.wpp });
              this.$refs.fila.getFila(session);
            }
          }, 5000);
        }

      },

      async autenticarEmpresas(count) {
        if (count === 0 && !this.authRequests) this.authRequests = new Map();
        if (count < this.empresas.length) {
          const connectionId = this.empresas[count].connectionId;
          this.autenticar(count, () => {
            const current = this.empresas[count];
            this.autenticarEmpresas(current && current.connectionId === connectionId ? count + 1 : count);
          })

        } else if (this.empresas.length) {
          this.authRequests = null;
          try {
            await this.$store.dispatch('configs/carregarConfigsEmpresas', this.$http);
          } catch (error) {
            if (this.isElectron) {
              this.errServer = 'Não foi possível carregar as configurações do Bot. Reinicie para tentar novamente.';
              return;
            }
          }

          this.$store.dispatch('finalizeEmpresas');
          this.pesquisa.keys = [...new Set(this.empresas.map(e => e.key))];

          if (this.isElectron) {
            this.$store.commit('SET_CAN_PLAY', true);
            const version = await window.control.getAppVersion();
            this.$store.commit('SET_VERSION', version);

            // Aplicativos antigos precisam atualizar para usar a consulta de versões no Electron.
            const startup = window.control.getStartupInfo
              ? await window.control.getStartupInfo(Number(this.empresas[0].id_empresa))
              : { updateRequired: true };

            this.$store.commit('SET_WPP_VERSION', startup.wppVersion);

            if (startup.updateRequired) {
              this.$router.push('/versao');
              this.load = false;

            } else if (startup.error) {
              this.errServer = startup.error;
              return;

            } else {
              this.getAtendimentos();

              window.control.login({
                empresas: this.empresas,
                base_server: this.base_server
              });
            }

          } else {
            this.$swal({
              text: 'Ação necessária para ativar o som das notificações',
              button: "Inicializar agora"
            }).then((r) => {
              this.$store.commit('SET_CAN_PLAY', true);
              this.getAtendimentos();
            });
          }

          [...new Set(this.empresas.map(e => e.token))].forEach(token => { this.$socket.emit('empresa_connected', token)});
          this.$store.dispatch('restoreWppSessions');

          this.load = false;

        } else {
          this.logout();
        }
      },

      iniciar() {
        this.$store.dispatch('hydrateEmpresas', {
          parseJSONObject: this.$helpers.parseJSONObject
        });

        if (this.empresas && this.empresas.length) {
          this.errServer = "Autenticando..";
          this.autenticarEmpresas(0);

        } else {
          localStorage.removeItem('key');
          localStorage.removeItem('token');

          if (!['Login','RecuperarSenha'].includes(this.$route.name)) {
            this.$router.push('/');
          }

          setTimeout(() => {
            this.load = false;
          }, 1000);
        }
      }
    },

    mounted() {
      this.iniciar();
      this.pedidosTimer = setInterval(() => this.atualizarPedidos(), 5 * 60 * 1000);

      if (!this.audio) {
        this.audio = new Audio("https://lecard-cdn.nyc3.cdn.digitaloceanspaces.com/lecard-gestor/lebot-bell.mp3");
      }
    },

    beforeDestroy() { clearInterval(this.pedidosTimer); },

    watch: {
      pedidosContexto() { this.atualizarPedidos(); }
    },

    created() {
      // Usar pra testar no navegador o Bot
      // document.dispatchEvent(new CustomEvent('wpp_session', { detail: {phone: '5516993626508',key: 'a4168c87dd0e85065d7b371e31481e96',token: 'hhhtatululuwjbaw3ron5psf2qr3',wpp: null,id_empresa: '2',bandeiras: null}}));

      setTimeout(() => {
        this.$store.commit('SET_IS_READY', true);
      }, 10000);

      if (this.isElectron) {
        window.control.onErrorReply((data) => {
          if (data) {
            this.$swal(data);
          }
        });

        window.control.onWppSession((data) => {
          this.$store.dispatch('addWppSession', data);
          this.getAtendimentos();

          setTimeout(() => {
            this.$refs.fila.loopFila();
          }, 15000);
        });

        window.control.onLebotStatus((data) => {
          this.$store.commit('SET_CONFIG', data);
        });

        window.control.onRequestHuman(() => {
          this.requestHuman();
        });

        window.control.onUpdateReply((data) => {
          this.$store.commit('SET_UPDATE_REPLY', data);
        });

        window.control.onUpdateProgress((data) => {
          this.$store.commit('SET_UPDATE_PROGRESS', data);
        });
      }
    },

    sockets: {
      connect() {
        if (this.empresas && this.isReady) {
          console.log('empresa_connected');
          [...new Set(this.empresas.map(e => e.token))].forEach(token => { this.$socket.emit('empresa_connected', token)});
        }
      },

      chatbot_pedido(data) {
        const empresa = this.empresas.find(e => e.isDefault);
        if (empresa && data && String(data.id_empresa) === String(empresa.id_empresa)) this.atualizarPedidos();
      },

      request_human(data) {
        this.requestHuman(data);
      },

      delivery_whatsapp(token) {
        const session = token ? this.wpp_session.find(w => w.token === token) : null;

        if (session) {
          this.$refs.fila.getFila(session);
        }
      }
    },

    computed: {
      loadingGeral() {
        return this.$store.state.load;
      },

      wpp_session() {
        return this.$store.state.wpp_session
      },

      empresas() {
        return this.$store.state.empresas
      },

      pedidosContexto() {
        if (!this.$store.getters['configs/leiaAtiva']) return null;
        const empresa = this.empresas.find(e => e.isDefault) || {};
        return empresa.connectionId + ':' + (empresa.x_auth || '');
      },

      x_auth() {
        return ((this.empresas.find((empresa) => empresa.isDefault) || {}).x_auth) || ''
      },

      canPlay() {
        return this.$store.state.canPlay
      },

      isReady() {
        return this.$store.state.isReady
      }
    }
  }
</script>
